var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UiCalendar, UiButton } from '@claims-ia/design-system';
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
const qualification = namespace('qualification');
let DateAndTimePicker = class DateAndTimePicker extends Vue {
    get formattedValue() {
        return this.modelValue ? this.formatDate(this.modelValue) : '';
    }
    get formattedMin() {
        return this.min ? this.formatDate(this.min) : null;
    }
    get maxDateTime() {
        if (this.$route.query.disableFrontDamageMaxDate) {
            return null;
        }
        return this.max ? this.formatDate(this.max) : this.todayFormatted;
    }
    get todayFormatted() {
        const now = new Date();
        return this.formatDate(now);
    }
    formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        if (this.type === 'datetime') {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        }
        return `${year}-${month}-${day}`;
    }
    isValidDate(dateStr) {
        const regex = this.type === 'datetime' ? /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/ : /^\d{4}-\d{2}-\d{2}$/;
        return regex.test(dateStr);
    }
    isSameDate(date1, date2) {
        if (!date2)
            return false;
        return date1.getTime() === date2.getTime();
    }
    onInput(value) {
        let newDate = null;
        if (value instanceof Date) {
            newDate = value;
        }
        else if (typeof value === 'string' && this.isValidDate(value)) {
            newDate = this.type === 'datetime' ? this.parseDateTime(value) : this.parseDate(value);
        }
        if (!newDate || isNaN(newDate.getTime()))
            return;
        if (this.modelValue && this.isSameDate(newDate, this.modelValue))
            return;
        this.$emit('update:modelValue', newDate);
    }
    parseDate(dateStr) {
        const parts = dateStr.split('-').map(Number);
        if (parts.length < 3)
            return null;
        const [year, month, day] = parts;
        return new Date(year, month - 1, day);
    }
    parseDateTime(dateTimeStr) {
        const [datePart, timePart] = dateTimeStr.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hours, minutes] = timePart.split(':').map(Number);
        if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) {
            return null;
        }
        const maxDays = new Date(year, month, 0).getDate();
        if (day > maxDays)
            return null;
        return new Date(year, month - 1, day, hours, minutes);
    }
};
__decorate([
    qualification.State('typeTrigram')
], DateAndTimePicker.prototype, "typeTrigram", void 0);
DateAndTimePicker = __decorate([
    Component({
        components: { UiCalendar, UiButton },
        props: {
            modelValue: {
                type: Date,
                default: null,
            },
            max: {
                type: Date,
                default: null,
            },
            min: {
                type: Date,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'date',
            },
        },
    })
], DateAndTimePicker);
export default DateAndTimePicker;
